module.exports = __webpack_public_path__ + "img/performance-tiao-icon3.ec3180e4.png";